import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import {
    PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID,
    ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID,
} from 'owa-folders-constants';

/**
 * Use isDeletedItemsFolderFromAnyMailboxV2 instead
 * Utility to check whether a folder is deleted items folder for any mailbox
 * @param folderId - the folderId.Id property of the folder
 * VSO-108969 - Remove isDeletedItemsFolderFromAnyMailbox and use V2  based in distinguishedFolderIds
 */
export default function isDeletedItemsFolderFromAnyMailbox(folderId: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (17,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return (
        folderId &&
        (doesFolderIdEqualName(folderId, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID) ||
            doesFolderIdEqualName(folderId, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID))
    );
}
